/**
 * @generated SignedSource<<ce2c73e0e278c6f778c06c7cfae2b0e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TradeOfferViewQuery$variables = {
  offerId: string;
};
export type TradeOfferViewQuery$data = {
  readonly tradeOffer: {
    readonly asset: {
      readonly __typename: string;
      readonly id: string;
      readonly isActive: boolean | null | undefined;
      readonly isBuyActive: boolean | null | undefined;
      readonly isSellActive: boolean | null | undefined;
      readonly legalUrl: string | null | undefined;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
      readonly portfolio: {
        readonly assetBalance: PrecisionFloat | null | undefined;
        readonly fiatBalance: PrecisionFloat | null | undefined;
      } | null | undefined;
      readonly priceBuy: PrecisionFloat | null | undefined;
      readonly priceSell: PrecisionFloat | null | undefined;
      readonly symbol: string | null | undefined;
    };
    readonly assetAmount: PrecisionFloat;
    readonly assetConversionRate: PrecisionFloat;
    readonly assetNetConversionRate: PrecisionFloat;
    readonly createdAt: TimeScalar;
    readonly expiresAtInMilliseconds: number;
    readonly expiresAtInSeconds: number;
    readonly fiatAmount: PrecisionFloat;
    readonly hasTaxOfflineWarning: boolean | null | undefined;
    readonly id: string;
    readonly kid: string | null | undefined;
    readonly spread: PrecisionFloat;
    readonly stockExchangeName: string | null | undefined;
    readonly taxAmount: PrecisionFloat | null | undefined;
    readonly totalAmount: PrecisionFloat | null | undefined;
    readonly volume: PrecisionFloat;
    readonly warnings: ReadonlyArray<{
      readonly linkMessage: string | null | undefined;
      readonly linkMessageKey: string | null | undefined;
      readonly message: string | null | undefined;
      readonly messageKey: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type TradeOfferViewQuery = {
  response: TradeOfferViewQuery$data;
  variables: TradeOfferViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "offerId"
      }
    ],
    "concreteType": "TradeOffer",
    "kind": "LinkedField",
    "name": "tradeOffer",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "symbol",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceSell",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceBuy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "legalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isBuyActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSellActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetPortfoliosConnection",
            "kind": "LinkedField",
            "name": "portfolio",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assetBalance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fiatBalance",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasTaxOfflineWarning",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fiatAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taxAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAtInSeconds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAtInMilliseconds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spread",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetConversionRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stockExchangeName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetNetConversionRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "volume",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TradeWarning",
        "kind": "LinkedField",
        "name": "warnings",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "messageKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkMessageKey",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TradeOfferViewQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TradeOfferViewQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2c4953cf3202d783ef6e74c050f943cb",
    "id": null,
    "metadata": {},
    "name": "TradeOfferViewQuery",
    "operationKind": "query",
    "text": "query TradeOfferViewQuery(\n  $offerId: ID!\n) {\n  tradeOffer(id: $offerId) {\n    id\n    createdAt\n    asset {\n      id\n      symbol\n      logoUrl\n      name\n      priceSell\n      priceBuy\n      legalUrl\n      isActive\n      isBuyActive\n      isSellActive\n      portfolio {\n        assetBalance\n        fiatBalance\n      }\n      __typename\n    }\n    hasTaxOfflineWarning\n    fiatAmount\n    assetAmount\n    totalAmount\n    taxAmount\n    expiresAtInSeconds\n    expiresAtInMilliseconds\n    spread\n    assetConversionRate\n    stockExchangeName\n    assetNetConversionRate\n    volume\n    kid\n    warnings {\n      message\n      messageKey\n      linkMessage\n      linkMessageKey\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "38ca239d865dd352216c0f159dbcda71";

export default node;
